<template>
    <v-layout justify-center>
        <v-dialog v-model="show" width="600px">
            <v-card >
                <v-toolbar dark color="blue lighten-2" class="titlebar">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Информация по переходам</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container fluid>
                        <div class="pa-0"
                                     v-for="(jump, index) in jumps"
                                     :key="jump.id"
                        >
                            <jump-card
                                    :model="jump"
                                    :index="index"
                                    @editModel="editModel(index)"
                                    @removeModel="removeModel(index)"
                                    :visibleButtons="{}"
                            ></jump-card>
                        </div>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import JumpCard from './JumpCard'
export default {
    name: 'JumpInfoDialog',
    components: {
        JumpCard
    },
    props: ['visible', 'model', 'type'],
    watch: {
        visible(value) {
            if (value) {
                this.$store.dispatch('jumps/getJumpByParentIdAndTypeWithHistory', { type: this.type, parentId: this.model.id })
            }
        }
    },
    computed: {
        show: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapGetters({
            jumps: 'jumps/jumps',
            user: 'user/user',
            getJumpsInHistoryCash: 'jumps/getJumpInHistoryCashByTypeAndParentId'
        })
    }

}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
        width: 100vw;
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
    .content {
        flex-grow: 1;
        overflow-x: auto;
    }
</style>
